import { render, staticRenderFns } from "./AccountMyAccount.vue?vue&type=template&id=749c3e8f&scoped=true&"
import script from "./AccountMyAccount.vue?vue&type=script&lang=js&"
export * from "./AccountMyAccount.vue?vue&type=script&lang=js&"
import style0 from "./AccountMyAccount.vue?vue&type=style&index=0&id=749c3e8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749c3e8f",
  null
  
)

export default component.exports